import React from 'react';
import useAppState from '../../AppStore';
import { ToolNames } from '../ToolNames';
import NoLegendMessage from './NoLegendMessage';

const NoLegend = () => {
  const activeTool = useAppState((state) => state.activeTool);
  const setActiveTool = useAppState((state) => state.setActiveTool);

  return (
    <div className="tooldialog__wrapper-content">
      <NoLegendMessage
        textKey="no_legend"
        showButton={activeTool === ToolNames.layerSelection}
        handleOnClick={() => setActiveTool(ToolNames.layerSelection)}
      />
    </div>
  );
};

export default NoLegend;
